module.exports = __webpack_public_path__ + "static/media/img-slide-1@3x.806faf63.png";